import { render, staticRenderFns } from "./CCreditNoteDetails.vue?vue&type=template&id=d6c1b34a&scoped=true"
import script from "./CCreditNoteDetails.vue?vue&type=script&lang=ts"
export * from "./CCreditNoteDetails.vue?vue&type=script&lang=ts"
import style0 from "./CCreditNoteDetails.vue?vue&type=style&index=0&id=d6c1b34a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c1b34a",
  null
  
)

export default component.exports